import React from 'react';
import './Order.css';
import moment from 'moment';
import OrderProduct from '../OrderProduct/OrderProduct';

function Order({ order }) {
  let price = order.data.amount / 100;
  const priceDollars = price.toString().split('.')[0];
  let priceCents = price.toString().split('.')[1];
  if (priceCents === undefined) priceCents = '00';
  if (priceCents.length < 2) priceCents += '0';

  return (
    <div className="order">
      <p>{moment.unix(order.data.created).format('MMMM Do YYYY, h:mma')}</p>
      <p className="order__id">
        <small>{order.id}</small>
      </p>
      {order.data.cart?.map((product, index) => (
        <OrderProduct
          key={index}
          id={product.item.id}
          title={product.item.title}
          image={product.item.image}
          price={product.item.price}
          rating={product.item.rating}
          quantity={product.quantity}
        />
      ))}
      <p>
        Order Total:&nbsp;
        <span className="app__priceSymbol">$</span>
        <strong className="app__priceDollars">{priceDollars}</strong>
        <span className="app__priceCents">{priceCents}</span>
      </p>
    </div>
  );
}

export default Order;
